import React, { useEffect, useState } from 'react';
import { Form } from '@ant-design/compatible';
import { Select } from 'antd';
import { renderKeywords } from 'utils/helpers';

const KEYWORDS_PADDING = 20;

function Keywords({
  getFieldDecorator,
  campaignKeywords,
  keywordsLoading,
  resetKeywords,
  setFieldsValue,
}) {
  const [keywordsLength, setKeywords] = useState(KEYWORDS_PADDING);
  const campaignKeywordsLength = campaignKeywords?.split(';').length;

  const resetKeywordsIfClear = keywords => {
    if (keywords?.length === 0) {
      resetKeywords();
    }
  };

  useEffect(() => {
    if (campaignKeywords) {
      setFieldsValue({ keywords: renderKeywords(campaignKeywords) });
    }
  }, [campaignKeywords]); //eslint-disable-line

  return (
    <Form.Item style={{ marginBottom: 0 }}>
      {getFieldDecorator('keywords', {
        initialValue: renderKeywords(campaignKeywords),
      })(
        <Select
          data-test="keywordsSelector"
          id="select"
          mode="tags"
          size="default"
          allowClear
          loading={keywordsLoading}
          placeholder="Add a keyword +"
          dropdownClassName="selectKeywordsDropdown"
          maxTagCount={keywordsLength}
          onChange={resetKeywordsIfClear}
          maxTagPlaceholder={() => {
            return (
              <div
                onClick={() => {
                  setKeywords(keywordsLength + KEYWORDS_PADDING);
                }}
              >
                + {campaignKeywordsLength - keywordsLength} more...
              </div>
            );
          }}
        />,
      )}
    </Form.Item>
  );
}

export default Keywords;
